import GuidelinesGrid from "../shared/GuidelinesGrid";

const GuidelinesDropdown = () => {
  return <GuidelinesGrid variant="dropdown" showCloseButton={false} />;
};

export default GuidelinesDropdown;
